import { render, staticRenderFns } from "./ModernisierterBoden.vue?vue&type=template&id=457bb118"
import script from "./ModernisierterBoden.vue?vue&type=script&lang=js"
export * from "./ModernisierterBoden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports